import { FormGroup, FormControl } from '@angular/forms';
import { DeviceBase } from './device-base';
import { RegisterElement } from "../element-decorator";
import { Lane } from "../access-control/lane";
import { PropertyMetadata } from '../../properties/property-types';
import { NetworkDeviceBase } from './network-device-base';

@RegisterElement()
export class TrafficLight extends NetworkDeviceBase {
    public override TypeName: string = "TrafficLight";
    protected override sizeInMeters: number = 1;
    public override ParentType: string | null = "Lane";
    public override ParentFormGroupName: string | null = "TrafficLights";

    constructor(formGroup: FormGroup) {
        super(formGroup, '/assets/icons/trafficlight.svg');

        // Add form controls specific to TrafficLight
        if (!formGroup.contains('Type')) {
            formGroup.addControl('Type', new FormControl('k3sign'));
        }
        if (!formGroup.contains('IsInverted')) {
            formGroup.addControl('IsInverted', new FormControl(false));
        }
        if (!formGroup.contains('Brightness')) {
            formGroup.addControl('Brightness', new FormControl(100));
        }
        if (!formGroup.contains('WorkflowDriven')) {
            formGroup.addControl('WorkflowDriven', new FormControl(false));
        }
        if (!formGroup.contains('ShowGreenFor')) {
            formGroup.addControl('ShowGreenFor', new FormControl('Entry'));
        }
    }

    public override getPropertyMetadata(): PropertyMetadata[] {
        return [
            ...super.getPropertyMetadata(),
            {
                formControlName: 'Type',
                displayName: 'Traffic Light Type',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'k1sign', label: 'K1 Sign' },
                        { value: 'k3sign', label: 'K3 Sign' },
                        { value: 'relaysign', label: 'Relay Sign' }
                    ]
                },
                order: 7,
                category: 'Properties'
            },
            {
                formControlName: 'IsInverted',
                displayName: 'Is Inverted',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'true', label: 'True' },
                        { value: 'false', label: 'False' }
                    ]
                },
                order: 8,
                category: 'Properties'
            },
            {
                formControlName: 'Brightness',
                displayName: 'Brightness',
                inputType: { 
                    type: 'number',
                    min: 0,
                    max: 100
                },
                order: 9,
                category: 'Properties'
            },
            {
                formControlName: 'WorkflowDriven',
                displayName: 'Drive Traffic Light by',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'true', label: 'Workflow' },
                        { value: 'false', label: 'Lane Direction' }
                    ]
                },
                order: 10,
                category: 'Properties'
            },
            {
                formControlName: 'ShowGreenFor',
                displayName: 'Show Green For',
                inputType: { 
                    type: 'select',
                    options: [
                        { value: 'Entry', label: 'Entry' },
                        { value: 'Exit', label: 'Exit' }
                    ]
                },
                order: 11,
                category: 'Properties'
            }
        ];
    }

    public override clone(): TrafficLight {
        return new TrafficLight(this.formGroup);
    }

    public override default(): TrafficLight {
       return this;
    }
} 
